import React from "react";
import { Link, useParams } from "react-router-dom";

const CourseNav = (props) => {

	const { lesson, topic } = useParams();
  
	return (
		<div className="intructions-wrap bg-white rounded-3 py-3 shadow-sm">
			{ props?.courseData &&
				<>
					{props?.courseData?.course_title &&
						<>
							<span className="text-uppercase placeholder-text px-3 d-inline-block w-100">Guide: {props?.courseData?.course_title}</span>
						</>
					}
					<nav className="nav flex-column mt-2 mb-3">
						{Object.keys(props?.courseData).map((lessonID, i) => (
							<div className="lesson-wrap test" key={i} >

								{props?.courseData[lessonID].name &&
									<Link
										to={`/${props?.slug}/${props?.courseData[lessonID].name}`} 
										className={`nav-link placeholder-text d-flex align-items-center border-top  w-100 ${((lesson === props?.courseData[lessonID].name && !topic) || (!lesson && i === 0)) ? 'bg-halite-blue text-white' : 'text-halite-blue'}`} >
										<span className="ms-2 text-uppercase" dangerouslySetInnerHTML={{__html: props?.courseData[lessonID].title}}></span>
									</Link>
								}

								{ props?.courseData[lessonID].topics && Object.keys(props?.courseData[lessonID].topics).length > 0 &&
									<div className={`topics-wrap mb-3 ${(lesson === props?.courseData[lessonID].name || (!lesson && !topic && i === 0)) ? '' : 'd-none'}`}>
										{Object.keys(props?.courseData[lessonID].topics).map((topicKey, j) => (
											<Link 
												to={`/${props?.slug}/${props?.courseData[lessonID].name}/${props?.courseData[lessonID].topics[topicKey].post_name}`} 
												className={`nav-link placeholder-text py-0 ps-4 mt-1  ${(window.location.pathname === `/${props?.slug}/${props?.courseData[lessonID].name}/${props?.courseData[lessonID].topics[topicKey].post_name}`) ? 'bg-halite-blue text-white' : 'text-halite-blue'}`} 
												key={`${lessonID + j}`}
											>
												<span className="ps-2 d-flex align-items-center">
													<i className="fa fa-circle" aria-hidden="true"></i>
													<span className="ms-2" dangerouslySetInnerHTML={{__html: props?.courseData[lessonID].topics[topicKey].post_title}}></span>
												</span>
											</Link>
										))}
									</div>
								}

							</div>
						))}
					</nav>
				</>
				
			}

		</div>
	);
};

export default CourseNav;